import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import getTheme from '../MuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

var LLRadioButton = /*#__PURE__*/function (_Component) {
  _inherits(LLRadioButton, _Component);

  var _super = _createSuper(LLRadioButton);

  function LLRadioButton() {
    _classCallCheck(this, LLRadioButton);

    return _super.apply(this, arguments);
  }

  _createClass(LLRadioButton, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(RadioButton, {
        value: this.props.value,
        label: this.props.label,
        style: this.props.style
      });
    }
  }]);

  return LLRadioButton;
}(Component);

_defineProperty(LLRadioButton, "propTypes", {
  label: PropTypes.string,
  style: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  theme: PropTypes.object.isRequired
});

_defineProperty(LLRadioButton, "defaultProps", {
  style: {},
  onChange: null,
  value: null,
  label: null
});

export { LLRadioButton as default };